/**
 * @file Helpers for the MessagesEmpty component
 */

import { getCanCreateMessage } from '../../utils/permissions/message';
import { getIsBasic } from '../../utils/permissions/storage';

/**
 * Get the translation key for the subtitle based on hotel status and permissions
 *
 * @returns Translation key for the subtitle
 */
export const getSubtitleKey = () => {
  if (getIsBasic()) {
    return 'TOPIC__EMPTY__SUBTITLE_BASIC';
  }
  return getCanCreateMessage()
    ? 'TOPIC__EMPTY__SUBTITLE'
    : 'TOPIC__EMPTY__SUBTITLE_LIMITED_PERMISSION';
};

/**
 * Get the translation key for the title based on hotel status
 *
 * @returns Translation key for the title
 */
export const getTitleKey = () => {
  if (getIsBasic()) {
    return 'TOPIC__EMPTY__TITLE_BASIC';
  }
  return 'TOPIC__EMPTY__TITLE';
};
